import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { SelectModule } from 'primeng/select';
import { AuthData } from '../../interfaces/generic.interface';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthStateService } from '../../services/authstate.service';

@Component({
  selector: 'app-login-screen',
  imports: [
    CommonModule,
    FormsModule,
    FloatLabelModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    TranslocoDirective,
    SelectModule,
    RouterLink
  ],
  templateUrl: './login-screen.component.html',
  styleUrl: './login-screen.component.scss'
})
export class LoginScreenComponent {

  constructor(
    private authService: AuthenticationService,
    private authState: AuthStateService
  ) {
    this.authState.changes$.next("LOGIN_WAIT")
  }

  authData: AuthData = {}

  login() {
    if (this.authData.username !== undefined && this.authData.password !== undefined) {
      this.authService.performLogin(this.authData);
    }
  }
}
